import { useEffect, useState } from 'react';
import iamApi from '../services/iamApi';
import { useAuth } from '../contexts/AuthContext';

// Shared `project_id → project name` map for the active org, so cross-project
// search results (the ⌘K palette and the top-bar dropdown) can label which
// project each match belongs to. Cached module-level per org so the two
// consumers don't each refetch.
const cache = new Map(); // orgId -> { [projectId]: name }

export function useProjectMap() {
  const { activeOrg } = useAuth();
  const [map, setMap] = useState(() => cache.get(activeOrg) || {});

  useEffect(() => {
    if (!activeOrg) { setMap({}); return undefined; }
    if (cache.has(activeOrg)) { setMap(cache.get(activeOrg)); return undefined; }
    let cancelled = false;
    Promise.resolve(iamApi.projects(activeOrg))
      .then((rows) => {
        const m = {};
        (Array.isArray(rows) ? rows : []).forEach((p) => {
          if (p && p.id) m[p.id] = p.name || p.title || p.id;
        });
        cache.set(activeOrg, m);
        if (!cancelled) setMap(m);
      })
      .catch(() => { if (!cancelled) setMap({}); });
    return () => { cancelled = true; };
  }, [activeOrg]);

  return map;
}

// Test helper: clear the module-level cache so a fresh mock takes effect per test.
export function __resetProjectMapCache() { cache.clear(); }

export default useProjectMap;
